// extracted by mini-css-extract-plugin
export default {"header_wrapper":"SuccessfulOrder_header_wrapper__loMck","main_height":"SuccessfulOrder_main_height__EkB1Q"};